define('modules/map/map_overlay_item_view',[
  'backbone',
  'jquery',
  '_',

  'text!./map_overlay_item_template.html'
], function (Backbone, $, _,
             map_overlay_item_template) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {

      _.extend(this, opts);

      this.calculatePositions();

      this.render();
    },

    template: _.template(map_overlay_item_template),

    render: function () {
      this.$el.html(this.template(this.player));
      return this;
    },

    calculatePositions: function () {
      var $player = this.$el.parent().find('img[data-id="' + this.player.get('id') + '"]:first'),
        offset = $player.position(),
        x = offset.left - 78,
        y = offset.top - 180 - (20 * this.player.get('zones').length);
      this.player = _.extend(this.player.toJSON(), {position_top: y, position_left: x});
    },

    remove: function () {
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }

  });

  return View;
});

